import { forwardRef, useId } from "react";

export const formClasses =
  "block w-full appearance-none rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm";

export function Label({ id, children }) {
  return (
    <label
      htmlFor={id}
      className="mb-3 block text-sm font-medium text-gray-700"
    >
      {children}
    </label>
  );
}

const TextField = forwardRef(
  ({ label, type = "text", className, ...props }, ref) => {
    let id = useId();

    return (
      <div className={className}>
        {label && (
          <Label id={id}>
            {label}
            <span className="text-red-600">*</span>
          </Label>
        )}
        <input
          id={id}
          type={type}
          ref={ref}
          {...props}
          className={formClasses}
        />
      </div>
    );
  }
);

export default TextField;
